import React, { useEffect, useState } from "react";
import { IndividualSettingData } from "../../component/SidebarItems";
import { FormattedMessage } from "react-intl";
import { getLocalAppSettings } from "sr/helpers/functions/getUserDetails";
import { useSelector } from "react-redux";
import { RootState } from "sr/redux/store";
export const Sidebar = ({ activeTab, HandleTabs }) => {
  const [menu, setMenu] = useState([]);
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  // const appSettingsData = useSelector((state: any) => {
  //   return state.appSettings.data;
  // });

  useEffect(() => {
    // console.log("appSettingsData", appSettingsData);
    setMenu(
      IndividualSettingData.filter((data) => {
        if (
          appSettingsData?.isAllowJobProviderPaymentSettings === false &&
          data.text.props.defaultMessage === "Payment Setting"
        ) {
          return false;
        }
        return true;
      }),
    );
  }, [appSettingsData]);

  return (
    <div className="h-screen bg-white rounded-lg py-4">
      <h1 className="px-3  text-xl">
        <FormattedMessage id="INDIVIDUAL.SETTINGS" defaultMessage="Settings" />
      </h1>
      <ul>
        {menu.map((data) => (
          <li
            onClick={() => HandleTabs(data.text)}
            className={`cursor-pointer flex items-center rounded-lg hover:rounded hover:bg-[#EEF1FE] my-2 px-3 py-2 ${
              activeTab === data.text.props.defaultMessage
                ? "bg-[#EEF1FE] border border-[#0078ae]"
                : ""
            }`}
          >
            <span className="p-1.5">{data.icon}</span>
            <div>
              <div className={`block  text-base`}>
                <span>{data.text}</span>
              </div>
              <div className={`block text-sm`}>
                <span>{data.smalltext}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
